/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "SupportedPeripheral": {
                "fields": {
                  "key": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "type": {
                    "type": ".squareup.connect.v2.SupportedPeripheral.PeripheralType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "manufacturerName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "modelName": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "usbDeviceClass": {
                    "type": "int32",
                    "id": 5,
                    "rule": "optional"
                  },
                  "usbVid": {
                    "type": "int32",
                    "id": 6,
                    "rule": "optional"
                  },
                  "usbPid": {
                    "type": "int32",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "usbProductName": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "barcodeScannerDetails": {
                    "type": ".squareup.connect.v2.SupportedBarcodeScannerDetails",
                    "id": 9
                  },
                  "cashDrawerDetails": {
                    "type": ".squareup.connect.v2.SupportedCashDrawerDetails",
                    "id": 10
                  }
                },
                "nested": {
                  "PeripheralType": {
                    "values": {
                      "PERIPHERAL_TYPE_UNKNOWN": 0,
                      "SCANNER": 1,
                      "CHIP_CARD_READER": 2,
                      "STAND_INTERNAL_CHIP_CARD_READER": 3,
                      "DRAWER": 4,
                      "ETHERNET_ADAPTER": 5
                    }
                  },
                  "type_details": {
                    "oneof": ["barcodeScannerDetails", "cashDrawerDetails"]
                  }
                }
              },
              "SupportedBarcodeScannerDetails": {
                "fields": {
                  "maxDelayBetweenHidInReports": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "useBootSubclass": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "supports2dBarcodes": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "suppressEmptyHidReports": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "SupportedCashDrawerDetails": {
                "fields": {
                  "openCommand": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "statusOpen": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "statusClosed": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.SupportedPeripheral && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.SupportedPeripheral?.nested?.PeripheralType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.SupportedBarcodeScannerDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.SupportedCashDrawerDetails) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SupportedPeripheral @ squareup/devices/external/supported_peripheral.proto at 10:1
 */
export const SupportedPeripheral = $root.lookupType('squareup.connect.v2.SupportedPeripheral');
fixType(SupportedPeripheral);
Builder.createAndAttachToType(SupportedPeripheral);
/**
 * SOURCE PeripheralType @ squareup/devices/external/supported_peripheral.proto at 16:3
 */
SupportedPeripheral.PeripheralType = $root.lookupEnum('squareup.connect.v2.SupportedPeripheral.PeripheralType').values;
/**
 * SOURCE SupportedBarcodeScannerDetails @ squareup/devices/external/supported_peripheral.proto at 56:1
 */
export const SupportedBarcodeScannerDetails = $root.lookupType('squareup.connect.v2.SupportedBarcodeScannerDetails');
fixType(SupportedBarcodeScannerDetails);
Builder.createAndAttachToType(SupportedBarcodeScannerDetails);
/**
 * SOURCE SupportedCashDrawerDetails @ squareup/devices/external/supported_peripheral.proto at 72:1
 */
export const SupportedCashDrawerDetails = $root.lookupType('squareup.connect.v2.SupportedCashDrawerDetails');
fixType(SupportedCashDrawerDetails);
Builder.createAndAttachToType(SupportedCashDrawerDetails);